import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import Header from '../../components/Header'
import CssBaseline from '@material-ui/core/CssBaseline';
import Menubar from '../../components/Menubar';
import { Stepper, Step, StepLabel, Button, Typography, Grid, Box, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Step1, Step2, Step3 } from '../../components/broadcast/AddGroupContact'

const steps = ['Tambah Kontak', 'Review Kontak', 'Selesai'];
const useStyles = makeStyles((theme) => ({
    appBar: {
      position: 'relative',
    },
    layoutMainCreateApp: {
      background: "white",
      padding: "2rem 2rem",
      borderRadius: "10px",
      [theme.breakpoints.up("sm")]: {
        width: "80%",
        marginLeft: 'auto',
        marginRight: 'auto',
      },
    },
    stepper: {
      padding: theme.spacing(3, 0, 5),
    },
    buttons: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
    button: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
      marginLeft: theme.spacing(1),
    },
    contentCreateApp : {
      paddingTop: "3%",
      paddingLeft: "15%",
      backgroundColor: "#e8e8e8",
      paddingRight: "5%",
      paddingBottom: "14%",

      [theme.breakpoints.down("sm")]: {
        paddingTop: "30%",
        paddingLeft: "0",
        paddingRight: "0"
      },
    },
}));



const NewContact = () => {
    const classes = useStyles();
    const history = useHistory()
    const [activeStep, setActiveStep] = React.useState(0);
    const [skipped, setSkipped] = React.useState(new Set());
    const [contactArray, setContactArray] = useState([]);
    const [group, setGroup] = useState('');
    const [isDisabled, setIsDisabled] = useState(true)
  
    const isStepSkipped = (step) => {
      return skipped.has(step);
    };
  
    const handleNext = () => {
      let newSkipped = skipped;
      if (isStepSkipped(activeStep)) {
        newSkipped = new Set(newSkipped.values());
        newSkipped.delete(activeStep);
      }
  
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      setSkipped(newSkipped);
    };
  
    const handleBack = () => {
      // setActiveStep((prevActiveStep) => prevActiveStep - 1);
      setIsDisabled(true)
      history.push('/broadcast/group')
    };
    
    // const handleReset = () => {
    //   setActiveStep(0);
    // };

    const handleContact = (data) => {
      setContactArray(data)
    }

    const handleGroup = (data) => {
      setGroup(data)
    }

    useEffect(() => {
      if (activeStep === 0 && contactArray.length > 0) {
        setIsDisabled(false)
      } else if ((activeStep === 1 && group['groupName']) || (activeStep === 1 && group['groupId'])) {
        setIsDisabled(false)
      } else {
        setIsDisabled(true)
      }
    }, [activeStep, contactArray, group])

    return (
        <React.Fragment>
        <Header page='CreateApp'/>
        <CssBaseline />
        <Menubar/>
        <Grid item xs={12} md={12} className={classes.contentCreateApp}>
        <main className={classes.layoutMainCreateApp}>
            <Typography align="center" color="textPrimary" spacing={4} gutterBottom className="mt-30 reguler font-size-28">
              Tambah Grup Kontak
            </Typography>
            <Box sx={{ width: '100%' }}>
              <Stepper activeStep={activeStep}>
                {steps.map((label, index) => {
                  const stepProps = {};
                  const labelProps = {};

                  return (
                    <Step key={label} {...stepProps}>
                      <StepLabel {...labelProps}>{label}</StepLabel>
                    </Step>
                  );
                })}
              </Stepper>
            </Box>
            <Grid container spacing={3} style={{justifyContent: "center"}}>
                <Grid item xs={12} md={12}>
                  {
                      activeStep === 0 && <Step1 contact={handleContact}/>
                  }
                  {
                      activeStep === 1 && <Step2 contact={contactArray} group={handleGroup}/>
                  }
                  {
                      activeStep === 2 && <Step3 contact={contactArray} group={group}/>
                  }
                </Grid>
                <Grid item xs={12} md={12} className="mt-5 d-flex" style={{justifyContent: "flex-end"}}>
                  {
                    (activeStep === 0 || activeStep === 1) &&
                    <div>

                  <Button
                    className="btn-white mx-4 text-transform-unset"
                    spacing={5}
                    onClick={handleBack}
                    style={{padding: "5px 40px"}}
                  >
                    Batal
                  </Button>
                  <Button
                    type="submit"
                    disabled={isDisabled}
                    className={isDisabled? "btn-grey text-grey text-transform-unset" : "btn-black text-transform-unset" }
                    spacing={5}
                    onClick={handleNext}
                    style={{padding: "5px 40px"}}
                  >
                    Selanjutnya
                  </Button>
                    </div>
                  }
                </Grid>
            </Grid>
          </main>
        </Grid>
      </React.Fragment>     
    )
}

export default NewContact